import toast from 'react-hot-toast';
import { useMemo } from 'react';

interface ToastOptions {
    duration?: number;
    position?: 'top-center' | 'top-right' | 'top-left' | 'bottom-center' | 'bottom-right' | 'bottom-left';
}

export const useToast = () => {
    return useMemo(() => {
        const success = (title: string, description?: string, options?: ToastOptions) => {
            const message = description ? `${title}\n${description}` : title;
            return toast.success(message, {
                duration: options?.duration || 4000,
                position: options?.position || 'top-right',
            });
        };

        const error = (title: string, description?: string, options?: ToastOptions) => {
            const message = description ? `${title}\n${description}` : title;
            return toast.error(message, {
                duration: options?.duration || 8000,
                position: options?.position || 'top-right',
            });
        };

        const warning = (title: string, description?: string, options?: ToastOptions) => {
            const message = description ? `${title}\n${description}` : title;
            return toast(message, {
                duration: options?.duration || 8000,
                position: options?.position || 'top-right',
                icon: '⚠️',
            });
        };

        const info = (title: string, description?: string, options?: ToastOptions) => {
            const message = description ? `${title}\n${description}` : title;
            return toast(message, {
                duration: options?.duration || 4000,
                position: options?.position || 'top-right',
                icon: 'ℹ️',
            });
        };

        const loading = (title: string, description?: string, options?: ToastOptions) => {
            const message = description ? `${title}\n${description}` : title;
            return toast.loading(message, {
                position: options?.position || 'top-right',
            });
        };

        const dismiss = (toastId?: string) => {
            if (toastId) {
                toast.dismiss(toastId);
            } else {
                toast.dismiss();
            }
        };

        return {
            success,
            error,
            warning,
            info,
            loading,
            dismiss,
        };
    }, []);
};